/* eslint-disable react/destructuring-assignment */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/jsx-props-no-spreading */
import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import {
  Modal,
  //Segment,
  Loader,
  //Dimmer,
  Checkbox,
  Portal,
  Ref,
  Popup,
} from 'semantic-ui-react';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import $ from 'jquery';
import { withTranslation } from 'react-i18next';
import dragbarImg from '../../images/components/my/drager.svg';
import downIcon from '../../images/components/content_wide_card/headerSorting (down).png';
import upIcon from '../../images/components/content_wide_card/headerSorting (up).png';
import api from '../../api';
import SystemsSubHeader from './SystemsSubHeader';
import DeleteLDAPModal from '../Modal/DeleteLDAPModal';
import NewLDAPModal from '../Modal/NewLDAPModal';
import EditLDAPModal from '../Modal/EditLDAPModal';
import WithRouter from '../Extensions/WithRouter';

class LDAPSystem extends Component {
  constructor(props) {
    super(props);
    this.modalHeader = null;
    this.modalBody = null;
    this.state = {
      searchKeyword: '',
      filters: '',
      pageSize: 20,
      isOpenMDL: false,
      isOpenMCL: false,
      isOpenMEL: false,
      isCheckedAll: false,
      isLoading: false,
      isNextLoading: false,
      isSort: false,
      isOpenAlert: false,
      isLoadingWithSync: false,
      isOrderError: false,
      isPageLoading: false,
      error: '',
      sortValue: '1',
      ldapList: [],
      checkValue: [],
      selectedId: '',
    };
    this.onDragEnd = this.onDragEnd.bind(this);
    this.handleOnScroll = this.handleOnScroll.bind(this);
    this.handleCheckAllChange = this.handleCheckAllChange.bind(this);
    this.handleCheckChange = this.handleCheckChange.bind(this);
    this.handleFilterData = this.handleFilterData.bind(this);
    this.handleActiveSync = this.handleActiveSync.bind(this);
    this.handleDeleteLDAP = this.handleDeleteLDAP.bind(this);
    this.handleDeleteCallback = this.handleDeleteCallback.bind(this);
    this.handleAddNewLDAP = this.handleAddNewLDAP.bind(this);
    this.handleMELOpen = this.handleMELOpen.bind(this);
    this.onChangeSorting = this.onChangeSorting.bind(this);
    this.onChangeSearch = this.onChangeSearch.bind(this);
    this.createLdapCallback = this.createLdapCallback.bind(this);
    this.clearSearch = this.clearSearch.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentDidMount() {
    window.addEventListener('scroll', this.handleOnScroll);
    $(document).on(
      'mouseover',
      '.setting_project_content .setting_project_table .content_wrapper',
      function () {
        const $this = $(this);
        if (this.offsetWidth < this.scrollWidth && !$this.attr('title')) {
          $this.attr('title', $this.text());
        }
      }
    );
    this.onUpdateLoading();
  }

  componentDidUpdate(prevProps, prevState) {
    const { isPageLoading } = this.state;
    const { location } = this.props;

    if (prevState.isPageLoading !== isPageLoading && isPageLoading) {
      this.getsLDAPListWithSystems();
      this.setState({
        isPageLoading: false,
      });
    }

    if (prevProps.location && location) {
      const currentPath = location.pathname ? location.pathname : location;
      const prevPath = prevProps.location.pathname ? prevProps.location.pathname : prevProps.location;
      if (currentPath !== prevPath) {
        this.requiredAdmin();
      }
    }
  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleOnScroll);
  }

  handleOnScroll() {
    const {
      getsLDAPListWithSystems,
      state: {
        error, isNextLoading, hasMore, currentPage
      },
    } = this;
    const scrollHeight = Math.max(
      document.documentElement.scrollHeight,
      document.body.scrollHeight
    );
    const scrollTop = Math.max(document.documentElement.scrollTop, document.body.scrollTop);
    const { clientHeight } = document.documentElement;

    if (error || isNextLoading || !hasMore) {
      return;
    }

    if (scrollTop + clientHeight >= scrollHeight) {
      getsLDAPListWithSystems(currentPage + 1);
    }
  }

  handleActiveSync = () => {
    const { t } = this.props;
    const { checkValue } = this.state;

    if (checkValue.length === 0) {
      this.modalHeader = t('modal.title.attention');
      this.modalBody = t('modal.message.select_one_ldap');
      this.setState({
        isOpenAlert: true,
      });
    } else {
      const obj = {
        ldap_ids: checkValue,
      };

      this.setState({
        isLoadingWithSync: true,
      }, () => {
        api
          .setSyncLDAPLatestStatus(obj)
          .then(() => {
            this.modalHeader = t('modal.title.notice');
            this.modalBody = t('modal.message.ldap_sync');
            this.setState({
              isLoadingWithSync: false,
              isOpenAlert: true,
              ldapList: [],
            }, () => {
              this.getsLDAPListWithSystems();
            });
          })
          .catch((err) => {
            console.log(err);
            const o = err.data.response;
            this.modalHeader = t('modal.title.attention');

            if (o.error_description) {
              this.modalBody = o.error_description;
              this.setState({
                isLoadingWithSync: false,
                isOpenAlert: true,
              });
            } else if (o.error === '422-752') {
              this.modalBody = t('modal.error.invalid_access');
              this.setState({
                isLoadingWithSync: false,
                isOpenAlert: true,
              });
            } else {
              this.modalBody = t('modal.error.unknow_error');
              this.setState({
                isLoadingWithSync: false,
                isOpenAlert: true,
              });
            }

            this.setState({
              ldapList: [],
            }, () => {
              this.getsLDAPListWithSystems();
            });
          });
      });
    }
  };

  handleCheckChange(e, { value }) {
    const { checkValue, ldapList } = this.state;
    let newState;
    if (checkValue.indexOf(value) > -1) {
      newState = checkValue.filter((el) => {
        return el !== value;
      });
    } else {
      newState = [...checkValue, value];
    }

    if (newState.length !== 0 && newState.length !== ldapList.length) {
      this.setState({
        checkValue: newState,
        isCheckedAll: false,
      });
    } else {
      this.setState({
        checkValue: newState,
      });
    }
  }

  handleCheckAllChange() {
    const { isCheckedAll, ldapList } = this.state;
    const newState = [];

    if (isCheckedAll) {
      this.setState({
        isCheckedAll: false,
        checkValue: [],
      });
    } else {
      const num = ldapList.length;
      let i = 0;
      for (i; i < num; i++) {
        newState.push(ldapList[i].id);
      }

      const unique = newState.reduce((a, b) => {
        if (a.indexOf(b) < 0) {
          a.push(b);
        }
        return a;
      }, []);
      this.setState({
        isCheckedAll: true,
        checkValue: unique,
      });
    }
  }

  handleFilterData(value) {
    this.setState(
      {
        ldapList: [],
        filters: value.filter,
      },
      () => {
        this.getsLDAPListWithSystems();
      }
    );
  }

  handleAddNewLDAP = () => {
    this.setState({
      isOpenMCL: true,
    });
  };

  handleMELOpen = (id) => {
    this.setState({
      selectedId: id,
      isOpenMEL: true,
    });
  };

  handleDeleteLDAP = () => {
    const { t } = this.props;
    const { checkValue } = this.state;
    if (checkValue.length === 0) {
      this.modalHeader = t('modal.title.attention');
      this.modalBody = t('modal.message.select_one_ldap');
      this.setState({
        isOpenAlert: true,
      });
    } else {
      this.setState({
        isOpenMDL: true,
      });
    }
  };

  handleDeleteCallback = () => {
    this.setState({
      isOpenMDL: false,
      isCheckedAll: false,
      ldapList: [],
      checkValue: [],
    }, () => {
      this.getsLDAPListWithSystems();
    });
  };

  onUpdateLoading() {
    this.setState({
      isPageLoading: true,
    });
  }

  onDragEnd = (result) => {
    const { t } = this.props;
    const {
      ldapList, isSort, sortValue, isOrderError
    } = this.state;
    const { source, destination } = result;
    if (sortValue !== '1') {
      this.modalHeader = t('modal.title.attention');
      this.modalBody = t('modal.message.change_priority');
      this.setState({
        isOpenAlert: true,
      });
      return null;
    }

    if (sortValue === '1' && isSort) {
      this.modalHeader = t('modal.title.attention');
      this.modalBody = t('modal.message.change_priority');
      this.setState({
        isOpenAlert: true,
      });
      return null;
    }
    if (!destination) {
      return null;
    }

    if (source.droppableId === destination.droppableId && source.droppableId === 'droppable') {
      if (result.source.index === result.destination.index) {
        return null;
      }
      const items = this.reorder(
        ldapList,
        result.source.index,
        result.destination.index
      );

      if (isOrderError) {
        this.setState({
          isOrderError: false,
        });
        return null;
      }

      this.setState({
        ldapList: items,
      });
    }
  };

  onChangeSorting = (e) => {
    const { isSort } = this.state;
    if (e.currentTarget.dataset.id !== this.state.sortValue) {
      this.setState(
        {
          sortValue: e.currentTarget.dataset.id,
          isSort: false,
          ldapList: [],
        },
        () => {
          this.getsLDAPListWithSystems();
        }
      );
    } else {
      this.setState(
        {
          sortValue: e.currentTarget.dataset.id,
          isSort: !isSort,
          ldapList: [],
        },
        () => {
          this.getsLDAPListWithSystems();
        }
      );
    }
  };

  onChangeSearch = (value) => {
    this.setState(
      {
        searchKeyword: value,
        ldapList: [],
      },
      () => {
        this.getsLDAPListWithSystems();
      }
    );
  };

  getsLDAPListWithSystems = (pageNo, limit) => {
    const {
      searchKeyword, filters, pageSize, sortValue, isSort, ldapList
    } = this.state;
    const { t } = this.props;
    let text;
    let filterData;
    const page = pageNo || 1;
    const perPage = limit || pageSize;

    if (filters.length !== 0) {
      let i = 0;
      for (i; i < filters.length; i++) {
        if (i === 0) {
          filterData = filters[i];
        } else {
          filterData = `${filterData},${filters[i]}`;
        }
      }
    } else {
      filterData = '';
    }

    switch (true) {
    case sortValue === '1':
      if (isSort) {
        text = 'priority';
      } else {
        text = 'priority_r';
      }
      break;
    case sortValue === '2':
      if (isSort) {
        text = 'name';
      } else {
        text = 'name_r';
      }
      break;
    case sortValue === '3':
      if (isSort) {
        text = 'host';
      } else {
        text = 'host_r';
      }
      break;
    case sortValue === '4':
      if (isSort) {
        text = 'port_r';
      } else {
        text = 'port';
      }
      break;
    case sortValue === '5':
      if (isSort) {
        text = 'base_dn';
      } else {
        text = 'base_dn_r';
      }
      break;
    case sortValue === '6':
      if (isSort) {
        text = 'filter';
      } else {
        text = 'filter_r';
      }
      break;
    case sortValue === '7':
      if (isSort) {
        text = 'usage_r';
      } else {
        text = 'usage';
      }
      break;
    case sortValue === '8':
      if (isSort) {
        text = 'auto_sync_r';
      } else {
        text = 'auto_sync';
      }
      break;
    case sortValue === '9':
      if (isSort) {
        text = 'status_r';
      } else {
        text = 'status';
      }
      break;
    default:
      text = 'priority_r';
      break;
    }

    const obj = {
      search: searchKeyword,
      filter: filterData,
      page,
      limit: perPage,
      order: text,
    };

    if (page === 1) {
      this.setState({
        isLoading: true,
      });
    } else {
      this.setState({
        isNextLoading: true,
      });
    }

    api
      .getsLDAPListWithSystems(obj)
      .then((response) => {
        const data = response.response;

        this.setState({
          currentPage: response.pagination.current,
          pageSize: response.pagination.per_page,
          hasMore: response.pagination.next !== null,
          isLoading: false,
          isNextLoading: false,
          ldapList: [...ldapList, ...data],
        });
      })
      .catch((err) => {
        console.log(err);
        this.setState({
          error: t('modal.error.error_load'),
          isLoading: false,
          isNextLoading: false,
        });
      });
  };

  reorder = (list, startIndex, endIndex) => {
    const { t } = this.props;
    const obj = {
      src_id: list[startIndex].id,
      dest_id: list[endIndex].id,
      dest_pos: startIndex > endIndex ? 'above' : 'below',
    };

    const result = Array.from(list);
    const [removed] = result.splice(startIndex, 1);
    result.splice(endIndex, 0, removed);
    const reorderResult = result.map((item, index) => {
      return {
        auto_sync: item.auto_sync,
        base_dn: item.base_dn,
        filter: item.filter,
        host: item.host,
        id: item.id,
        ldap_priority: index + 1,
        name: item.name,
        port: item.port,
        use_ldap: item.use_ldap,
        sync_text: item.sync_text,
      };
    });

    api
      .updateOrderwithLDAPList(obj)
      .then()
      .catch((err) => {
        console.log(err);
        const o = err.data.response;
        this.modalHeader = t('modal.title.attention');

        if (o.error_description) {
          this.modalBody = o.error_description;
          this.setState({
            isOpenAlert: true,
            isOrderError: true,
          });
        } else if (o.error === '422-752') {
          this.modalBody = t('modal.error.invalid_access');
          this.setState({
            isOpenAlert: true,
            isOrderError: true,
          });
        } else {
          this.modalBody = t('modal.error.unknow_error');
          this.setState({
            isOpenAlert: true,
            isOrderError: true,
          });
        }
      });
    return reorderResult;
  };

  createLdapCallback() {
    this.setState({
      ldapList: [],
      isOpenMCL: false,
      isOpenMEL: false,
    }, () => {
      this.getsLDAPListWithSystems();
    });
  }

  requiredAdmin() {
    const { state, navigate } = this.props;
    if (!state.user.isAdmin) {
      if (localStorage.getItem('main_page') === 'dashboard') {
        navigate('/main', { replace: true });
      } else if (localStorage.getItem('main_page') === 'results') {
        navigate('/results', { replace: true });
      } else {
        navigate(`/results/${this.props.state.user.main_page}`, { replace: true });
      }
    }
  }

  clearSearch() {
    this.setState(
      {
        searchKeyword: '',
        ldapList: [],
      },
      () => {
        this.getsLDAPListWithSystems();
      }
    );
  }

  closeModal() {
    this.setState({
      isOpenAlert: false,
      isOpenMDL: false,
      isOpenMCL: false,
      isOpenMEL: false,
    });
  }

  render() {
    const {
      isCheckedAll,
      isLoading,
      ldapList,
      checkValue,
      isSort,
      sortValue,
      error,
      isNextLoading,
      filters,
      isLoadingWithSync,
      isOpenMDL
    } = this.state;
    const { t } = this.props;

    const getListStyle = () => {
      return {
        width: '100%',
        zIndex: '1',
      };
    };

    const getItemStyle = (isDragging, draggableStyle) => {
      return {
        userSelect: 'none',
        background: isDragging ? '#fae7ff' : 'rgba(255, 255, 255, 0.8)',
        ...draggableStyle,
      };
    };

    const convertString = (value) => {
      let useSync;
      if (value === -1) {
        useSync = 'Off';
      } else {
        let ampm;
        if (value > 12 || value === 0) {
          ampm = 'PM';
        } else {
          ampm = 'AM';
        }
        const hours = value % 12;
        let number;
        if (hours) {
          if (hours < 10) {
            number = `0${hours}`;
          } else {
            number = hours;
          }
        } else {
          number = 12;
        }
        useSync = `${number} ${ampm}`;
      }
      return useSync;
    };

    const replaceToString = (value) => {
      const string = value.replace(/Sync Error:/g, '');
      return string;
    };

    const renderElement = (entity, provided, snapshot) => {
      return (
        <Ref
          innerRef={provided.innerRef}
        >
          <div
            className="setting_project_table_wrap"
            key={entity.id}
            ref={provided.innerRef}
            {...provided.draggableProps}
            {...provided.dragHandleProps}
            style={getItemStyle(
              snapshot.isDragging,
              provided.draggableProps.style
            )}
          >
            <table className="setting_project_table draggable_content">
              <colgroup>
                <col style={{ width: '36px' }} />
                <col style={{ width: '6%' }} />
                <col style={{ width: '160px' }} />
                <col style={{ width: '8%' }} />
                <col style={{ width: '6%' }} />
                <col style={{ width: '13%' }} />
                <col style={{ width: '13%' }} />
                <col style={{ width: '6%' }} />
                <col style={{ width: '12%' }} />
                <col style={{ width: '10%' }} />
                <col style={{ width: '7%' }} />
                <col style={{ width: '6%' }} />
              </colgroup>
              <tbody>
                <tr>
                  <td>
                    <div className="content_wrapper">
                      <Checkbox
                        value={entity.id}
                        checked={checkValue.indexOf(entity.id) > -1}
                        onChange={this.handleCheckChange}
                      />
                    </div>
                  </td>
                  <td>
                    <div className="content_wrapper">{entity.ldap_priority}</div>
                  </td>
                  <td>
                    <div className="content_wrapper">{entity.name}</div>
                  </td>
                  <td>
                    <div className="content_wrapper">{entity.host}</div>
                  </td>
                  <td>
                    <div className="content_wrapper">{entity.port}</div>
                  </td>
                  <td>
                    <div className="content_wrapper">{entity.base_dn}</div>
                  </td>
                  <td>
                    <div className="content_wrapper">{entity.filter}</div>
                  </td>
                  <td>
                    <div className="content_wrapper">
                      {entity.use_ldap === true ? 'On' : 'Off'}
                    </div>
                  </td>
                  <td>
                    <div className="content_wrapper">{convertString(entity.auto_sync)}</div>
                  </td>
                  <td>
                    {
                      entity.sync_text.indexOf('Sync Error') > -1 ? (
                        <Popup
                          trigger={<div className="content_wrapper">{t('modal.error.sync_error')}</div>}
                          content={replaceToString(entity.sync_text)}
                        />
                      ) : (
                        <div className="content_wrapper">{entity.sync_text}</div>
                      )
                    }
                  </td>
                  <td>
                    <div className="content_wrapper">
                      <a
                        className="edit_button"
                        onClick={() => {
                          this.handleMELOpen(entity.id);
                        }}
                        style={{ cursor: 'pointer' }}
                      >
                        {t('system.button.edit')}
                      </a>
                    </div>
                  </td>
                  <td>
                    <a className="drager_button">
                      <img src={dragbarImg} alt="" />
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </Ref>
      );
    };

    return (
      <DragDropContext onDragEnd={this.onDragEnd}>
        <div className="content">
          <div className="setting_small_box">
            <SystemsSubHeader
              onChangeSearch={this.onChangeSearch}
              clearSearch={this.clearSearch}
              onSubmit={this.handleFilterData}
              handleActiveSync={this.handleActiveSync}
              handleDeleteLDAP={this.handleDeleteLDAP}
              handleAddNewLDAP={this.handleAddNewLDAP}
              filter={filters}
              isLoadingWithSync={isLoadingWithSync}
              translate={t}
            />
            {
              isLoading ? (
                <Loader size="big" style={{ display: 'block', lineHeight: '25px' }}>
                  {t('list.title.loading')}
                </Loader>
              ) : (
                <div className="setting_project_content">
                  <table className="setting_project_table table_header">
                    <colgroup>
                      <col style={{ width: '36px' }} />
                      <col style={{ width: '6%' }} />
                      <col style={{ width: '160px' }} />
                      <col style={{ width: '8%' }} />
                      <col style={{ width: '6%' }} />
                      <col style={{ width: '13%' }} />
                      <col style={{ width: '13%' }} />
                      <col style={{ width: '6%' }} />
                      <col style={{ width: '12%' }} />
                      <col style={{ width: '10%' }} />
                      <col style={{ width: '7%' }} />
                      <col style={{ width: '6%' }} />
                    </colgroup>
                    <thead>
                      <tr>
                        <th>
                          <Checkbox
                            checked={isCheckedAll}
                            onChange={this.handleCheckAllChange}
                            disabled={ldapList.length === 0}
                          />
                        </th>
                        <th>
                          <a
                            className="sorting_button"
                            data-id="1"
                            onClick={this.onChangeSorting}
                          >
                            {t('system.list.priority')}
                            {isSort && sortValue === '1' ? <img src={upIcon} alt="" /> : null}
                            {!isSort && sortValue === '1' ? <img src={downIcon} alt="" /> : null}
                          </a>
                        </th>
                        <th>
                          <a
                            className="sorting_button"
                            data-id="2"
                            onClick={this.onChangeSorting}
                          >
                            {t('system.list.name')}
                            {isSort && sortValue === '2' ? <img src={upIcon} alt="" /> : null}
                            {!isSort && sortValue === '2' ? <img src={downIcon} alt="" /> : null}
                          </a>
                        </th>
                        <th>
                          <a
                            className="sorting_button"
                            data-id="3"
                            onClick={this.onChangeSorting}
                          >
                            {t('system.list.host')}
                            {isSort && sortValue === '3' ? <img src={upIcon} alt="" /> : null}
                            {!isSort && sortValue === '3' ? <img src={downIcon} alt="" /> : null}
                          </a>
                        </th>
                        <th>
                          <a
                            className="sorting_button"
                            data-id="4"
                            onClick={this.onChangeSorting}
                          >
                            {t('system.list.port')}
                            {isSort && sortValue === '4' ? <img src={upIcon} alt="" /> : null}
                            {!isSort && sortValue === '4' ? <img src={downIcon} alt="" /> : null}
                          </a>
                        </th>
                        <th>
                          <a
                            className="sorting_button"
                            data-id="5"
                            onClick={this.onChangeSorting}
                          >
                            {t('system.list.base_dn')}
                            {isSort && sortValue === '5' ? <img src={upIcon} alt="" /> : null}
                            {!isSort && sortValue === '5' ? <img src={downIcon} alt="" /> : null}
                          </a>
                        </th>
                        <th>
                          <a
                            className="sorting_button"
                            data-id="6"
                            onClick={this.onChangeSorting}
                          >
                            {t('system.list.filter')}
                            {isSort && sortValue === '6' ? <img src={upIcon} alt="" /> : null}
                            {!isSort && sortValue === '6' ? <img src={downIcon} alt="" /> : null}
                          </a>
                        </th>
                        <th>
                          <a
                            className="sorting_button"
                            data-id="7"
                            onClick={this.onChangeSorting}
                          >
                            {t('system.list.usage')}
                            {isSort && sortValue === '7' ? <img src={upIcon} alt="" /> : null}
                            {!isSort && sortValue === '7' ? <img src={downIcon} alt="" /> : null}
                          </a>
                        </th>
                        <th>
                          <a
                            className="sorting_button"
                            data-id="8"
                            onClick={this.onChangeSorting}
                          >
                            {t('system.list.automatic_sync')}
                            {isSort && sortValue === '8' ? <img src={upIcon} alt="" /> : null}
                            {!isSort && sortValue === '8' ? <img src={downIcon} alt="" /> : null}
                          </a>
                        </th>
                        <th>
                          <a
                            className="sorting_button"
                            data-id="9"
                            onClick={this.onChangeSorting}
                          >
                            {t('system.list.sync_status')}
                            {isSort && sortValue === '9' ? <img src={upIcon} alt="" /> : null}
                            {!isSort && sortValue === '9' ? <img src={downIcon} alt="" /> : null}
                          </a>
                        </th>
                        <th>&nbsp;</th>
                        <th>&nbsp;</th>
                      </tr>
                    </thead>
                  </table>
                  <Droppable droppableId="droppable">
                    {(provided, snapshot) => {
                      return (
                        <div
                          {...provided.droppableProps}
                          ref={provided.innerRef}
                          style={getListStyle(snapshot.isDraggingOver)}
                        >
                          {ldapList.length !== 0
                            ? ldapList.map((item, index) => {
                              return (
                                <Draggable
                                  key={item.id}
                                  draggableId={`ldap_${item.id}`}
                                  index={index}
                                >
                                  {(draggableProvided, draggableSnapshot) => {
                                    const child = renderElement(item, draggableProvided, draggableSnapshot, index);
                                    if (draggableSnapshot.isDragging) {
                                      return (
                                        <Portal
                                          className="setting_project_content is_dragging"
                                          open={draggableSnapshot.isDragging}
                                        >
                                          <div
                                            className="setting_project_table_wrap"
                                            key={item.id}
                                            ref={draggableProvided.innerRef}
                                            {...draggableProvided.draggableProps}
                                            {...draggableProvided.dragHandleProps}
                                            style={getItemStyle(
                                              draggableSnapshot.isDragging,
                                              draggableProvided.draggableProps.style
                                            )}
                                          >
                                            <table className="setting_project_table draggable_content">
                                              <colgroup>
                                                <col style={{ width: '36px' }} />
                                                <col style={{ width: '6%' }} />
                                                <col style={{ width: '160px' }} />
                                                <col style={{ width: '8%' }} />
                                                <col style={{ width: '6%' }} />
                                                <col style={{ width: '13%' }} />
                                                <col style={{ width: '13%' }} />
                                                <col style={{ width: '6%' }} />
                                                <col style={{ width: '12%' }} />
                                                <col style={{ width: '10%' }} />
                                                <col style={{ width: '7%' }} />
                                                <col style={{ width: '6%' }} />
                                              </colgroup>
                                              <tbody>
                                                <tr>
                                                  <td>
                                                    <div className="content_wrapper">
                                                      <Checkbox
                                                        value={item.id}
                                                        checked={checkValue.indexOf(item.id) > -1}
                                                        onChange={this.handleCheckChange}
                                                      />
                                                    </div>
                                                  </td>
                                                  <td>
                                                    <div className="content_wrapper">{item.ldap_priority}</div>
                                                  </td>
                                                  <td>
                                                    <div className="content_wrapper">{item.name}</div>
                                                  </td>
                                                  <td>
                                                    <div className="content_wrapper">{item.host}</div>
                                                  </td>
                                                  <td>
                                                    <div className="content_wrapper">{item.port}</div>
                                                  </td>
                                                  <td>
                                                    <div className="content_wrapper">{item.base_dn}</div>
                                                  </td>
                                                  <td>
                                                    <div className="content_wrapper">{item.filter}</div>
                                                  </td>
                                                  <td>
                                                    <div className="content_wrapper">
                                                      {item.use_ldap === true ? 'On' : 'Off'}
                                                    </div>
                                                  </td>
                                                  <td>
                                                    <div className="content_wrapper">{convertString(item.auto_sync)}</div>
                                                  </td>
                                                  <td>
                                                    {
                                                      item.sync_text.indexOf('Sync Error') > -1 ? (
                                                        <div className="content_wrapper">{t('modal.error.sync_error')}</div>
                                                      ) : (
                                                        <div className="content_wrapper">{item.sync_text}</div>
                                                      )
                                                    }
                                                  </td>
                                                  <td>
                                                    <div className="content_wrapper">
                                                      <a
                                                        className="edit_button"
                                                        onClick={() => {
                                                          this.handleMELOpen(item.id);
                                                        }}
                                                        style={{ cursor: 'pointer' }}
                                                      >
                                                        {t('system.button.edit')}
                                                      </a>
                                                    </div>
                                                  </td>
                                                  <td>
                                                    <a className="drager_button">
                                                      <img src={dragbarImg} alt="" />
                                                    </a>
                                                  </td>
                                                </tr>
                                              </tbody>
                                            </table>
                                          </div>
                                        </Portal>
                                      );
                                    }
                                    return child;
                                  }}
                                </Draggable>
                              );
                            })
                            : null}
                        </div>
                      );
                    }}
                  </Droppable>
                  {error && <div className="error_log">{error}</div>}
                  {isNextLoading && <Loader active={isNextLoading} size="medium">{t('list.title.loading')}</Loader>}
                </div>
              )
            }
          </div>
          <DeleteLDAPModal
            isOpenMDL={isOpenMDL}
            closeModal={this.closeModal}
            selectedIds={checkValue}
            handleDeleteCallback={this.handleDeleteCallback}
            translate={t}
          />
          <NewLDAPModal
            isOpenMCL={this.state.isOpenMCL}
            createLdapCallback={this.createLdapCallback}
            closeModal={this.closeModal}
            translate={t}
          />
          <EditLDAPModal
            isOpenMEL={this.state.isOpenMEL}
            ldapId={this.state.selectedId}
            updateLdapCallback={this.createLdapCallback}
            closeModal={this.closeModal}
            translate={t}
          />
          <Modal open={this.state.isOpenAlert} onClose={this.closeModal}>
            <div className="modal_popup_wrap">
              <div className="modal_popup_box">
                <div className="modal_popup">
                  <h2 className="title">{this.modalHeader}</h2>
                  <p className="text">{this.modalBody}</p>
                  <div className="button_wrap">
                    <a
                      className="center_button"
                      onClick={this.closeModal}
                      style={{ cursor: 'pointer' }}
                    >
                      {t('modal.button.ok')}
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </Modal>
        </div>
      </DragDropContext>
    );
  }
}

export default WithRouter(withTranslation()(inject('state')(observer(LDAPSystem))));
